<template>
  <v-card flat class="pa-6" color="transparent">
    <v-card-title class="d-flex justify-center" style="color: #616060; font-size: 30px;">
      Verificación de medios de contacto
    </v-card-title>
    <div class="pa-6 d-flex justify-center">
      <p style="color: #616060; font-size: 20px; width: 40%; text-align: justify;" class="nota">
        "Hemos enviado códigos de verificación a tus medios de contacto para confirmar que son correctos. Por favor, ingresa los códigos que recibiste."
      </p>
    </div>
    <v-container class="d-flex justify-center align-center" style = "margin-top: 50px">
      <v-form style="width: 30%" color="transparent" class="ingresocode">
        <v-row justify="center">
          <v-col cols="2" style="width: 100%;">
            <div class="mb-2 text-center">Código por correo</div>
            <v-text-field
                class="custom-input"
                outlined
                required
                v-model="emailCode"
                placeholder="Ingresa el código que recibiste por email"
                :rules="[formValidator.code.required, formValidator.code.length(6)]"
                maxlength="6"
            />
            <div class="mb-2 text-center">Código por SMS</div>
            <v-text-field
                class="custom-input"
                outlined
                required
                v-model="phoneCode"
                placeholder="Ingresa el código que recibiste por teléfono"
                :rules="[formValidator.code.required, formValidator.code.length(6)]"
                maxlength="6"
            />
          </v-col>
        </v-row>
        <v-btn block @click="resendVerificationCodeSame" color="main_color_action" large class="flex-fill mr-2"
               style="color: white; margin-top: 2rem">Validar codigos
        </v-btn>
        <v-btn block @click="resentCodeFirst" color="main_color_action" large class="flex-fill mr-2" :disabled="isDisabled"
               style="color: white; margin-top: 2rem"> {{ isDisabled ? `Espera ${countdown}s` : 'Reenviar códigos' }}
        </v-btn>
      </v-form>
    </v-container>


  </v-card>
</template>

<script>
import registerFormValidator from "../form/register.form.validator";

export default {
  props: {
    emailCode: String,
    phoneCode: String,
  },
  data() {
    return {
      formValidator: registerFormValidator,
    };
  },
  methods: {
    async verificarCodigo() {
      try {
        this.loadingVerify = true;
        const response = await this.$api.fetchData(
            `/auth/verify/${this.form.email}/${this.codigoVerificacion}`,
            "POST"
        );

        if (response.success) {
          this.$toast.success(response.message);
          this.showRegister = true;
        } else {
          this.$toast.error(response.message);
        }
      } catch (error) {
        this.$toast.error("Error al verificar el código.");
      } finally {
        this.loadingVerify = false;
      }
    },

    async reenviarCodigos() {
      try {
        this.loadingResend = true;
        const response = await this.$api.fetchData(
            `/auth/resend/${this.form.email}`,
            "POST"
        );

        if (response.success) {
          this.$toast.success(response.message);
        } else {
          this.$toast.error(response.message);
        }
      } catch (error) {
        this.$toast.error("Error al reenviar los códigos.");
      } finally {
        this.loadingResend = false;
      }
    }
  }

};
</script>

<style scoped>
@media (max-width: 991px){
  .ingresocode{
    width: 70% !important;
  }
  .nota{
    width: 90% !important;
  }

}
@media (max-width: 767px){

  .nota{
    width: 90% !important;
  }

}


</style>
